// extracted by mini-css-extract-plugin
module.exports = {"time":"AdReturnTime_time__1n8R3","city":"AdReturnTime_city__2VJZV"};